import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ContractorService } from '../../services/contractor/contractor.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { DisplayService } from '../../services/display/display.service';
import { HelpService } from '../../services/help/help.service';
import { PurchaseOrderService } from '../../services/purchase-order/purchase-order.service';
import { NoteService } from '../../services/note/note.service';
import { CalendarService } from '../../services/calendar/calendar.service';
import { InvoiceService } from '../../services/invoice/invoice.service';
import { AddonService } from '../../services/addon/addon.service';
import { UserService } from '../../services/user/user.service';
import { CommsService } from '../../services/comms/comms.service';

import _ from 'lodash';

@Component({
	selector: 'pcm-data-page-contractor',
	templateUrl: './data-page-contractor.component.html',
	styleUrls: ['./data-page-contractor.component.scss']
})
export class DataPageContractorComponent implements OnInit, OnDestroy {
	@ViewChild('headerActions') headerActions;

	dataObj = this.configService.contractorDataObj;
	timesheetDataObj = this.configService.timesheetDataObj;
	title = 'Contractor';

	dataConfig;
	rangeConfig;
	poNumber;
	contractorId;
	supplierId;

	showMultiCalendarModal = false;

	timesheetGoTo;
	minDate: NgbDateStruct;
	maxDate: NgbDateStruct;
	date: {
		year: number,
		month: number
	};

	defaultSort = [
		{
			prop: this.configService.startDateProp,
			dir: 'asc'
		}
	];

	timesheetsTabsData = {
		listTabs: [
			{
				prop: 'rejected',
				name: 'Rejected Timesheets'
			}, {
				prop: 'all',
				name: 'All Timesheets'
			}
		]
	};
	timesheetsTableColConfig = [];

	jrSteps = [];
	jrStepIDs = [];
	showPODetails = true;

	acceptedCalError = false;
	calendarAccessError = 'You do not have access to the invoice calendar that is assigned to this contractor\'s PO. Please contact your Supplier Administrator';

	contractorAddonsUpdateListener;
	contractorUpdateListener;

	showTimeRange = false;

	showWarrantyModal = false;
	showWarrantyIcon = false;
	allowReject = false;	// only support to reject contractor warranty

	showConfirmation = false;
	confirmationMessage = 'Are you sure you want to perform the action?';
	confirmationAction = 'APPROVE';	// APPROVE or REJECT

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public contractorService: ContractorService,
		public timesheetService: TimesheetService,
		public dataService: DataService,
		private noteService: NoteService,
		public configService: ConfigService,
		public displayService: DisplayService,
		public helpService: HelpService,
		private purchaseOrderService: PurchaseOrderService,
		public calendarService: CalendarService,
		public invoiceService: InvoiceService,
		private addonService: AddonService,
		public userService: UserService,
		private commService: CommsService
	) {
		this.helpService.contractor.forEach(step => {
			this.jrSteps.push(step);
			this.jrStepIDs.push(step.id);
		});

		if (this.configService.persona !== this.configService.personaProps['contractor']) {
			this.showPODetails = true;
		} else {
			this.showPODetails = false;
		}
		this.timesheetsTableColConfig = this.configService.getTableFields(this.timesheetService.dataObj, true);
	}

	ngOnInit() {
		console.log('PAGE CONTRACTOR INIT');
		this.addonService.loadContractorAddons();
		this.timesheetService.contractorPO = '';
		this.timesheetService.contractorId = '';
		this.contractorService.dataConfig = this.configService.getDataObj(this.contractorService.dataObj);
		this.dataConfig = this.configService.getDataObj(this.dataObj);
		this.rangeConfig = this.configService.getDataObj(this.configService.timesheetsRangeDataObj);
		this.contractorService.selectDefaultTab(this.contractorService.tabsData.tabs);

		// loadContractor will fire timeRangeChange event
		this.dataService.timeRangeChangeListener().subscribe((event) => {
			this.timesheetService.selectDefaultTab(this.timesheetService.tabsData.contractorListTabs);
			this.showTimeRange = true;
		});

		const self = this;
		self.route.params.subscribe(params => {
			self.poNumber = params['poNumber'];
			// need get the list of invoice calenders for the PO
			this.dataService.updateInvoiceCalendars([]);
			const data = {ponumber: self.poNumber};
			self.calendarService.loadCalendars(self.calendarService.tabsData.listTabs, data);
			self.showTimeRange = false;
			if (self.configService.persona === self.configService.personaProps['contractor']) {
				self.dataService.selectedPO = {
					name: self.poNumber,
					prop: self.poNumber
				};
			}
			self.contractorId = params['contractorId'];
			self.supplierId = params['supplierId'];

			self.timesheetService.contractorPO = self.poNumber;
			self.timesheetService.contractorId = self.contractorId;
			self.timesheetService.contractorSupplierId = self.supplierId;

			self.dataService.updatePOContractorSelections([]);
			this.contractorService.selectDefaultTab(this.contractorService.tabsData.migrateListTabs);
			self.contractorService.loadContractor(self.poNumber, self.contractorId, self.supplierId);
			if (self.configService.persona !== self.configService.personaProps['contractor']
				&& self.configService.persona !== self.configService.personaProps['tra']
			) {
				// for the renewal PO,
				// contractor edit tab needs the list of contractors from the previous PO
				self.purchaseOrderService.loadPO(self.poNumber, self.supplierId, true);
				self.contractorService.loadPOContractors(self.poNumber, self.contractorService.getPOAllTab(), true);
			}
		});

		this.contractorAddonsUpdateListener = this.dataService.contractorAddonsUpdateListener().subscribe((event) => {
			console.log('CONTRACTOR PAGE ADDONS UPDATED', this.dataService.contractorAddons);
			this.contractorService.dataConfig = this.configService.getDataObj(this.contractorService.dataObj, this.dataService.contractorAddons);
		});

		this.contractorUpdateListener = this.dataService.contractorUpdateListener().subscribe((event) => {
			this.timesheetsTableColConfig = this.configService.getTableFields(this.timesheetService.dataObj, true, this.dataService.contractorDetails[this.configService.countryCodeProp]);
			this.showWarrantyIcon = false;
			this.allowReject = false;
			if (self.dataService.contractorDetails['enableWarranty']
				&& (self.userService.persona === self.configService.personaProps.pm
					|| self.userService.persona === self.configService.personaProps.fa)) {
				this.showWarrantyIcon = true;
			}
			if (self.dataService.contractorDetails['warranty'] && self.userService.persona === self.configService.personaProps.sam) {
				this.allowReject = true;
			}
		});
	}

	ngOnDestroy() {
		console.log('DESTROY DATA PAGE CONTRACTOR');
		this.contractorAddonsUpdateListener.unsubscribe();
	}

	calendarUpdateSuccess() {
		console.log('PO CALENDAR UPDATE SUCCESS CALL', this.poNumber, this.supplierId);
		this.purchaseOrderService.loadPO(this.poNumber, this.supplierId, false);
	}

	checkPOInvoiceCalendar() {
		let multiplePOContractors = false;
		if (this.dataService.poContractors !== undefined) {
			if (this.dataService.poContractors.length > 1) {
				multiplePOContractors = true;
			}
		}
		if (!multiplePOContractors) {
			console.log('SINGLE PO CONTRACTOR');
			this.updatePOInvoiceCalendar();
		} else {
			console.log('MULTIPLE PO CONTRACTORS');
			this.showMultiCalendarModal = true;
		}
	}

	updatePOInvoiceCalendar() {
		console.log('ACCEPTABLE UPDATE PO INVOICE CALENDAR');
		this.showMultiCalendarModal = false;
		this.purchaseOrderService.updatePOInvoiceCalendar(this);
	}

	cancelCalendarModal() {
		this.dataService.poDetails[this.configService.calendarIdProp] = this.dataService.originalPODetails[this.configService.calendarIdProp];
		this.showMultiCalendarModal = false;
	}

	pageFormSubmit(event) {
		console.log('PAGE FORM SUBMIT', event, this.dataService.contractorDetails, this.dataService.poDetails[this.configService.calendarIdProp], this.dataService.originalPODetails[this.configService.calendarIdProp]);
		this.dataService.contractorDetails = event.data;
		// this.contractorService.submitContractor(this);
		if (this.dataService.poDetails[this.configService.calendarIdProp] !== this.dataService.originalPODetails[this.configService.calendarIdProp]) {
			console.log('INVOICE CALENDAR CHANGED', this.dataService.poDetails[this.configService.calendarIdProp], this.dataService.originalPODetails[this.configService.calendarIdProp]);
			this.checkPOInvoiceCalendar();
		} else {
			console.log('INVOICE CALENDAR UNCHANGED');
		}
		if (!_.isEqual(event.data, event.originalData)) {
			console.log('PAGE FORM DATA CHANGED', event.data, event.originalData);
			this.contractorService.submitContractor(this, event.data, event.originalData);
		} else {
			console.log('PAGE FORM DATA UNCHANGED');
		}
	}

	pageContentApprove() {
		// need confirmation if approval includes warranty (allowReject===true)
		if (this.allowReject) {
			this.confirmationMessage = this.contractorService.approveWarrantyConfirmation;
			this.confirmationAction = 'APPROVE';
			this.showConfirmation = true;
		} else {
			this.approveContractor();
		}
	}

	approveContractor(approvalstatus = '') {
		const poNumber = this.poNumber;
		const contractorId = this.dataService.contractorDetails[this.configService.contractorIdProp];
		const supplierId = this.dataService.contractorDetails[this.configService.supplierIdProp];
		if (approvalstatus === '') {
			approvalstatus = this.contractorService.approvalValues.approved;
		}
		this.contractorService.approveContractor(poNumber, contractorId, supplierId, approvalstatus, this);
	}

	pageContentReject() {
		this.confirmationMessage = this.contractorService.rejectWarrantyConfirmation;
		this.confirmationAction = 'REJECT';
		this.showConfirmation = true;
	}

	performAction() {
		if (this.confirmationAction === 'REJECT') {
			this.approveContractor('rejected');
		} else {
			this.approveContractor();
		}
		this.cancelConfirmation();
	}

	contractorSuccess() {
		console.log('CONTRACTOR SUCCESS CALL');
		// this is a HACK ...
		// submitting contractor edits recieves a 200 response
		// several seconds before data is available for query
		this.contractorService.loadContractor(this.poNumber, this.contractorId, this.supplierId);
		this.displayService.startLoading();
		const self = this;
		const delay = setTimeout(function () {
			self.contractorService.checkTabs(self.contractorService.tabsData.tabs);
			self.displayService.endLoading();
		}, 4000);
	}

	rangeFormSubmit(event) {
		console.log('RANGE FORM SUBMIT', event, this.dataService.timesheetsRange);
		this.dataService.updateTimesheetsRange(event.data);
	}

	openTimesheet(date) {
		const dates = {
			[this.configService.contractorStartProp]: this.dataService.contractorDetails[this.configService.contractorStartProp],
			[this.configService.contractorEndProp]: this.dataService.contractorDetails[this.configService.contractorEndProp]
		};
		this.timesheetService.openTimesheet(
			this.dataService.contractorDetails[this.configService.poNumberProp],
			this.dataService.contractorDetails[this.configService.contractorIdProp],
			this.dataService.contractorDetails[this.configService.supcontIdProp],
			this.dataService.contractorDetails[this.configService.supplierIdProp],
			date,
			dates
		);
	}

	poSelectionAction(event) {
		const po = event.action.name;
		console.log('selected po number: ', po);
		const poObj = this.dataService.userKeys[po];
		this.dataService.selectedPO = {
			name: po,
			prop: po
		};
		if (poObj) {
			this.dataService.selectedPO.tooltip = poObj.actualstartdate + ' - ' + poObj.actualenddate;
			const poNumber = poObj[this.configService.poNumberProp];
			const contractorId = poObj[this.configService.contractorIdProp];
			const supcontId = poObj[this.configService.supcontIdProp];
			const supplierId = poObj[this.configService.supplierIdProp];
			this.configService.supplierId = supplierId;
			this.contractorService.openContractor(poNumber, contractorId, supplierId);
		} else {
			this.noteService.displayError('failed to find PO for: ' + po);
		}
	}

	timesheetTablePage(event) {
		console.log('TIMESHEET TABLE PAGE: ', event);
		const activeTab = this.timesheetService.getActiveTab(this.timesheetService.tabsData.contractorListTabs);
		this.timesheetService.getActiveTab(this.timesheetService.tabsData.contractorListTabs)['page'] = event.offset;
		this.timesheetService.loadContractorTimesheetsForTab(activeTab);
	}

	calErrorCancel(event) {
		this.acceptedCalError = true;
	}

	showWarranty() {
		this.showWarrantyModal = true;
	}

	cancelWarrantyModal() {
		this.showWarrantyModal = false;
	}

	warrantyFormSubmit() {
		const self = this;
		const delay = setTimeout(function () {
			self.cancelWarrantyModal();
		}, 1000);

		const data = {
			uuid: this.dataService.contractorDetails[this.configService.contractorIdProp],
			ponumber: this.poNumber,
			supplierid: this.dataService.contractorDetails[this.configService.supplierIdProp]
		};
		this.commService.warrantContractor(data).subscribe((res) => {
			self.noteService.displaySuccess('The contractor has successfully been marked as warranty');
			self.dataService.updatePOContractorDetails(null);
			self.contractorSuccess();
			self.dataService.broadcastNotifications(self.dataObj);
		}, (err) => {
			self.commService.handleAPIError('Warranty Contractor', err);
		});
	}

	cancelConfirmation() {
		this.showConfirmation = false;
	}
}
